import { AbstractControl, ValidatorFn } from '@angular/forms';
import { CnpjAlfanumericoValidator } from './cnpj-alpha.validator';

export function cnpjValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const cnpj = control.value;
    if (!cnpj) {
      return null;
    }

    return CnpjAlfanumericoValidator.isValid(cnpj)
      ? null
      : { cnpjInvalid: { value: cnpj } };
  };
}
